import React from 'react'
import api from './api'
import { newReport } from '../common/types/api/report'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../common/components/Notification/Notification'
import i18n from 'live/services/i18n'

export default async function getNewReport(): Promise<newReport> {
    try {
        const res = await api<newReport>('new')
        if (!res.success) {
            GlobalNotification.error(
                <Notification title={i18n('Error trying to create a new report: ')}>{'unknown error'}</Notification>,
                20
            )

            console.error(res)
        }

        return res
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error trying to create a new report: ')}>{error}</Notification>,
            20
        )
        console.error(error)

        return null
    }
}
